import { __rest, __assign } from '../../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { useTheme } from '@mui/material';
import { VictoryTooltip, VictoryLabel, LineSegment, Point } from 'victory';

var ChartTooltip = React__default.memo(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var theme = useTheme();
    if (!props.text)
        return null;
    return (React__default.createElement("g", null,
        React__default.createElement(VictoryTooltip, __assign({}, props, { orientation: "top", cornerRadius: 8, flyoutStyle: { fill: theme.palette.neutral900, stroke: "none" }, pointerOrientation: "bottom", flyoutPadding: 8, labelComponent: React__default.createElement(VictoryLabel, { lineHeight: 1.5 }), style: [
                {
                    fill: theme.palette.neutral300,
                    fontSize: "14px",
                    fontFamily: theme.typography.fontFamily,
                },
                {
                    fill: theme.palette.neutral200,
                    fontSize: "15px",
                    fontWeight: 500,
                    fontFamily: theme.typography.fontFamily,
                },
            ] })),
        React__default.createElement(LineSegment, { x1: props.x, y1: props.y, x2: props.x, y2: props.height ? props.height - 20 : 0, style: {
                stroke: "#3e495b",
            } }),
        React__default.createElement(Point, { x: props.x, y: props.y, size: 5, style: {
                stroke: color !== null && color !== void 0 ? color : "#4c535e",
                fill: "#353234",
            } })));
}, function (prevProps, nextProps) { return prevProps.x === nextProps.x && prevProps.y === nextProps.y; });

export { ChartTooltip };
